module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Gameboy-394340313aa3d8455e7c8a394703ea9c.svg";